import React from 'react';
import ProjectManagerComponent from '../components/ProjectManagerComponent';

function Projects() {
    return (
        <div>
            <h1>Projects</h1>
            <ProjectManagerComponent />
        </div>
    );
}

export default Projects;
